__webpack_require__.p = "https://js-static.iimjobs.com/production/19.1.0/_next/";